/*
 * Registers the Discovery page at /discovery.
 *
 * Separate from /agents on purpose. That page is the fleet's own surface — the instruments,
 * their scope and whether they can look. This one is the estate they found. Conflating them
 * would undo the distinction that keeps agents out of the catalog in the first place.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const DISCOVERY_PATH = '/discovery';

const discoveryPage = PageBlueprint.make({
  name: 'stackschematic-discovery',
  params: {
    path: DISCOVERY_PATH,
    loader: async () => {
      const { DiscoveryPage } = await import('./DiscoveryPage');
      return <DiscoveryPage />;
    },
  },
});

export const stackSchematicDiscoveryModule = createFrontendModule({
  pluginId: 'app',
  extensions: [discoveryPage],
});
